// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"schedule-appointment-module--wrapper--2mVDI"};